import { memo, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { getUserIsAuth } from '../../../entities/User'
import { getRouteAdmin } from '../../lib/const/router'
import { Container } from '../Container'
import { LangSwitcher } from '../LangSwitcher/LangSwitcher'
import cls from './StickyHeader.module.scss'

interface StickyHeaderProps {
    onPrimaryCtaClick: () => void
}

export const StickyHeader = memo(({ onPrimaryCtaClick }: StickyHeaderProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const isAuth = useSelector(getUserIsAuth)

    const clickCountRef = useRef(0)
    const clickTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

    const isSpecialPage =
        location.pathname === '/login' || location.pathname.startsWith('/admin')

    const handleBrandClick = useCallback(() => {
        clickCountRef.current += 1

        if (clickTimerRef.current) {
            clearTimeout(clickTimerRef.current)
        }

        clickTimerRef.current = setTimeout(() => {
            const clicks = clickCountRef.current
            clickCountRef.current = 0

            if (isSpecialPage) {
                navigate('/')
                return
            }

            if (clicks >= 2) {
                navigate(isAuth ? getRouteAdmin() : '/login')
            } else {
                navigate('/')
            }
        }, 250)
    }, [isSpecialPage, isAuth, navigate])

    return (
        <header className={cls.root}>
            <Container className={cls.inner}>
                <div
                    className={cls.brand}
                    onClick={handleBrandClick}
                    style={{ cursor: 'pointer' }}
                >
                    VANLIFE<span className={cls.brandDot} />
                </div>
                <div className={cls.right}>
                    <LangSwitcher />
                    <button
                        type="button"
                        className={cls.cta}
                        onClick={onPrimaryCtaClick}
                    >
                        {t('hero.button')}
                    </button>
                </div>
            </Container>
        </header>
    )
})
